import {observer} from "mobx-react";
import {
    Box,
    Divider,
    FormControl,
    FormGroup,
    InputLabel,
    MenuItem,
    Select, TextField,
    Typography, useMediaQuery, useTheme
} from "@mui/material";
import {useStore} from "../../stores/Store";
import { contactInformationFormInput } from '../../styles';
import {Simulate} from "react-dom/test-utils";

export default observer(function(){
    const {LanguageStore, ContactFormStore} = useStore();
    const {currentLanguageMessages, currentLanguage} = LanguageStore;
    const { title, setTitle, firstName, setFirstName, lastName, setLastName,
        street, setStreet, houseNumber, setHouseNumber, zip, setZip, city,
        setCity, phone, setPhone, mobile, setMobile, email, setEmail, preferredMethodOfContact,
        setPreferredMethodOfContact, firstNameIsValid, lastNameIsValid,
        emailIsValid, phoneIsValid, mobileIsValid, additionalInformation, setAdditionalInformationFromEvent
    } = ContactFormStore;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <Box sx={{mt: 4}}>
            <Typography variant={'h6'}>Contact Information</Typography>
            <Divider sx={{mb: 2}} />
            <Box sx={{display: 'flex', justifyContent: 'center', textAlign: 'center', width: '100%'}}>
                <FormGroup>
                    <FormControl variant={'filled'} sx={contactInformationFormInput} >
                        <InputLabel id={'contact-information-title-select'}>{currentLanguageMessages.ContactPage.contactInformation.titleLabel}</InputLabel>
                        <Select
                            labelId={'contact-information-title-select'}
                            value={title}
                            onChange={setTitle}
                            required={true}
                        >
                            <MenuItem value={'Mr.'}>{currentLanguageMessages.ContactPage.contactInformation.titleMrValueLabel}</MenuItem>
                            <MenuItem value={'Ms.'}>{currentLanguageMessages.ContactPage.contactInformation.titleMsValueLabel}</MenuItem>
                        </Select>
                    </FormControl>
                    <Box>
                        <TextField
                            sx={isMobile ? {...contactInformationFormInput, width: '100%'} : {...contactInformationFormInput, mr: 2}}
                            required={true}
                            variant={"filled"}
                            onChange={setFirstName}
                            value={firstName}
                            label={currentLanguageMessages.ContactPage.contactInformation.firstNameLabel}
                            error={!firstNameIsValid}
                        />
                        <TextField
                            sx={isMobile ? {...contactInformationFormInput, width: '100%'} : contactInformationFormInput}
                            required={true}
                            variant={"filled"}
                            onChange={setLastName}
                            value={lastName}
                            label={currentLanguageMessages.ContactPage.contactInformation.lastNameLabel}
                            error={!lastNameIsValid}
                        />
                    </Box>
                    <Box>
                        <TextField
                            sx={isMobile ? {...contactInformationFormInput, width: '100%'} : {...contactInformationFormInput, mr: 2}}
                            required={false}
                            variant={"filled"}
                            onChange={setStreet}
                            value={street}
                            label={currentLanguageMessages.ContactPage.contactInformation.streetLabel}
                        />
                        <TextField
                            sx={isMobile ? {...contactInformationFormInput, width: '100%'} : contactInformationFormInput}
                            required={false}
                            variant={"filled"}
                            onChange={setHouseNumber}
                            value={houseNumber}
                            label={currentLanguageMessages.ContactPage.contactInformation.houseNumberLabel}
                        />
                    </Box>
                    <Box>
                        <TextField
                            sx={isMobile ? {...contactInformationFormInput, width: '100%'} : {...contactInformationFormInput, mr: 2}}
                            required={false}
                            variant={"filled"}
                            onChange={setZip}
                            value={zip}
                            label={currentLanguageMessages.ContactPage.contactInformation.zipLabel}
                        />
                        <TextField
                            sx={isMobile ? {...contactInformationFormInput, width: '100%'} : contactInformationFormInput}
                            required={false}
                            variant={"filled"}
                            onChange={setCity}
                            value={city}
                            label={currentLanguageMessages.ContactPage.contactInformation.cityLabel}
                        />
                    </Box>
                    <TextField
                        sx={contactInformationFormInput}
                        variant={"filled"}
                        onChange={setPhone}
                        value={phone}
                        label={currentLanguageMessages.ContactPage.contactInformation.phoneLabel}
                        error={!phoneIsValid}
                        required={preferredMethodOfContact === 'phone'}
                    />
                    <TextField
                        sx={contactInformationFormInput}
                        variant={"filled"}
                        onChange={setMobile}
                        value={mobile}
                        label={currentLanguageMessages.ContactPage.contactInformation.mobileLabel}
                        error={!mobileIsValid}
                        required={preferredMethodOfContact === 'mobile'}
                    />
                    <TextField
                        sx={contactInformationFormInput}
                        variant={"filled"}
                        onChange={setEmail}
                        value={email}
                        label={currentLanguageMessages.ContactPage.contactInformation.emailLabel}
                        error={!emailIsValid}
                        required={preferredMethodOfContact === 'email'}
                    />
                    <FormControl variant={'filled'} sx={contactInformationFormInput}>
                        <InputLabel id={'contact-information-method-select-label'}>{currentLanguageMessages.ContactPage.contactInformation.preferredMethodOfContactLabel}</InputLabel>
                        <Select
                            labelId={'contact-information-method-select-label'}
                            id={'contact-information-method-select'}
                            value={preferredMethodOfContact}
                            onChange={setPreferredMethodOfContact}
                            required={true}
                        >
                            <MenuItem value={'email'}>{currentLanguageMessages.ContactPage.contactInformation.emailLabel}</MenuItem>
                            <MenuItem value={'phone'}>{currentLanguageMessages.ContactPage.contactInformation.phoneLabel}</MenuItem>
                            <MenuItem value={'mobile'}>{currentLanguageMessages.ContactPage.contactInformation.mobileLabel}</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        sx={contactInformationFormInput}
                        multiline={true}
                        variant={'filled'}
                        label={currentLanguageMessages.ContactPage.contactInformation.additionalInformationTitle}
                        rows={6}
                        value={additionalInformation}
                        onChange={setAdditionalInformationFromEvent}
                    />
                </FormGroup>
            </Box>
        </Box>
    )
})
